import { H3, IconLockup, PortableText, TypeWrapper } from '@ahmdigital/ui';
import classNames from 'classnames';
import React from 'react';

import styles from './styles.module.sass';

type InclusionsItemProps = {
  description: unknown[];
  icon?: string;
  isOdd: boolean;
  itemTitle: string;
};

const InclusionsItem = ({ description, icon, isOdd, itemTitle }: InclusionsItemProps) => (
  <TypeWrapper variant={[styles.inclusion, 'paddingBottomSpacer10', 'paddingTopSpacer10']}>
    {/* @ts-expect-error - Automatic, Please fix when editing this file */}
    <div className={classNames({ [styles.oddInclusion]: isOdd })}>
      <IconLockup
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ className: string | undefined; name: string; size: string; type: string; }' is not assignable to type '({ name, size, ...restOfProps }: { name: "document" | "history" | "time" | "search" | "list" | "phone-circle" | "ambulance-services" | "ambulance" | "app-chevron-down" | "app-chevron-left" | "app-chevron-right" | ... 93 more ... | "youtube"; size?: "small" | ... 4 more ... | undefined; } & ComponentProps) => React.J...'.
        icon={{ className: styles.icon, name: `${icon}-circle`, size: 'small', type: 'included' }}
        variant={styles.iconLockup}
      >
        <H3 looksLike="h4">{itemTitle}</H3>
        {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type 'unknown[]' is not assignable to type 'PortableTextSource | undefined'. */}
        {description && <PortableText source={description} />}
      </IconLockup>
    </div>
  </TypeWrapper>
);

InclusionsItem.defaultProps = {
  icon: 'tick',
};

export default InclusionsItem;
